import React from "react";

import iconInstagram from './../../../assets/wp-content/uploads/2024/11/instagram.png'
import iconTelegram from './../../../assets/wp-content/uploads/2024/11/telegram.png'
import iconTiktok from './../../../assets/wp-content/uploads/2024/11/tiktok.png'
import iconYoutube from './../../../assets/wp-content/uploads/2024/11/youtube.png'
import iconFacebook from './../../../assets/wp-content/uploads/2024/11/facebook.png'


class SectionSocialNetwork extends React.Component{
    render(){
        return(

            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-2c46e24e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="2c46e24e"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-418b9dde"
                  data-id="418b9dde"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section
                      className="elementor-section elementor-inner-section elementor-element elementor-element-26f15ca0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="26f15ca0"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div
                          className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-67deb26b"
                          data-id="67deb26b"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-7bfd5a77 elementor-widget elementor-widget-heading"
                              data-id="7bfd5a77"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h6 className="elementor-heading-title elementor-size-default">
                                  Siga-nos
                                </h6>
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-32de8b5a elementor-widget elementor-widget-heading"
                              data-id="32de8b5a"
                              data-element_type="widget"
                              data-widget_type="heading.default"
                            >
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">
                                  Nossas Redes Sociais
                                </h2>
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-18912d9f elementor-widget elementor-widget-text-editor"
                              data-id="18912d9f"
                              data-element_type="widget"
                              data-widget_type="text-editor.default"
                            >
                              <div className="elementor-widget-container">
                                <p>
                                  Siga todas as nossas redes sociais para
                                  manter-se atualizado e acesse nosso grupo no
                                  Telegram para ter acesso a todos materiais
                                  OFICIAIS de divulgação.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <div
                      className="elementor-element elementor-element-4af9f50b e-grid e-con-boxed e-con e-parent"
                      data-id="4af9f50b"
                      data-element_type="container"
                    >
                      <div className="e-con-inner">
                        <div
                          className="elementor-element elementor-element-2287b642 elementor-position-top elementor-widget elementor-widget-image-box"
                          data-id="2287b642"
                          data-element_type="widget"
                          data-widget_type="image-box.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-image-box-wrapper">
                              <figure className="elementor-image-box-img">
                                <a
                                  href="https://www.instagram.com/sigmobioficial"
                                  target="_blank"
                                  tabIndex="-1"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width="70"
                                    height="70"
                                    src={iconInstagram}
                                    className="attachment-full size-full wp-image-49"
                                    alt=""
                                  />
                                </a>
                              </figure>
                              <div className="elementor-image-box-content">
                                <h3 className="elementor-image-box-title">
                                  <a
                                    href="https://www.instagram.com/sigmobioficial"
                                    target="_blank"
                                  >
                                    @sigmobioficial
                                  </a>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-4cd2f0a2 elementor-position-top elementor-widget elementor-widget-image-box"
                          data-id="4cd2f0a2"
                          data-element_type="widget"
                          data-widget_type="image-box.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-image-box-wrapper">
                              <figure className="elementor-image-box-img">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width="70"
                                  height="70"
                                  src={iconTelegram}
                                  className="attachment-full size-full wp-image-50"
                                  alt=""
                                />
                              </figure>
                              <div className="elementor-image-box-content">
                                <h3 className="elementor-image-box-title">
                                  @sigmobioficial
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-6705e49a elementor-position-top elementor-widget elementor-widget-image-box"
                          data-id="6705e49a"
                          data-element_type="widget"
                          data-widget_type="image-box.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-image-box-wrapper">
                              <figure className="elementor-image-box-img">
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width="70"
                                  height="70"
                                  src={iconTiktok}
                                  className="attachment-full size-full wp-image-51"
                                  alt=""
                                />
                              </figure>
                              <div className="elementor-image-box-content">
                                <h3 className="elementor-image-box-title">
                                  @sigmobioficial
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-43b1c413 elementor-position-top elementor-widget elementor-widget-image-box"
                          data-id="43b1c413"
                          data-element_type="widget"
                          data-widget_type="image-box.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-image-box-wrapper">
                              <figure className="elementor-image-box-img">
                                <a
                                  href="https://www.youtube.com/@SigMobiOficial"
                                  target="_blank"
                                  tabIndex="-1"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width="70"
                                    height="70"
                                    src={iconYoutube}
                                    className="attachment-full size-full wp-image-52"
                                    alt=""
                                  />
                                </a>
                              </figure>
                              <div className="elementor-image-box-content">
                                <h3 className="elementor-image-box-title">
                                  <a
                                    href="https://www.youtube.com/@SigMobiOficial"
                                    target="_blank"
                                  >
                                    @sigmobioficial
                                  </a>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-76a941a9 elementor-position-top elementor-widget elementor-widget-image-box"
                          data-id="76a941a9"
                          data-element_type="widget"
                          data-widget_type="image-box.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-image-box-wrapper">
                              <figure className="elementor-image-box-img">
                                <a
                                  href="https://www.facebook.com/profile.php?id=61563802990531"
                                  target="_blank"
                                  tabIndex="-1"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    width="70"
                                    height="70"
                                    src={iconFacebook}
                                    className="attachment-full size-full wp-image-48"
                                    alt=""
                                  />
                                </a>
                              </figure>
                              <div className="elementor-image-box-content">
                                <h3 className="elementor-image-box-title">
                                  <a
                                    href="https://www.facebook.com/profile.php?id=61563802990531"
                                    target="_blank"
                                  >
                                    @sigmobioficial
                                  </a>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

        );
    }
}

export default SectionSocialNetwork;